const MEMORY_TOKENS = new Map();

const SUBJECT_KEYS = {
  booking: 'booking',
  bookingRequest: 'bookingRequest',
};

const getStorageKey = (subjectType, referenceCode) => {
  const subjectKey = SUBJECT_KEYS[subjectType];
  const normalizedReference = String(referenceCode || '').trim().toUpperCase();
  if (!subjectKey || !normalizedReference) return null;
  return `chat:${subjectKey}:${normalizedReference}`;
};

export const storeChatAccessToken = (subjectType, referenceCode, token) => {
  const key = getStorageKey(subjectType, referenceCode);
  const normalizedToken = String(token || '').trim();
  if (!key || !normalizedToken) return false;

  MEMORY_TOKENS.set(key, normalizedToken);
  try {
    localStorage.setItem(key, normalizedToken);
    return true;
  } catch {
    return false;
  }
};

export const getChatAccessToken = (subjectType, referenceCode) => {
  const key = getStorageKey(subjectType, referenceCode);
  if (!key) return '';

  try {
    return localStorage.getItem(key) || MEMORY_TOKENS.get(key) || '';
  } catch {
    return MEMORY_TOKENS.get(key) || '';
  }
};

export const hasConversationNote = (...values) => values.some(
  (value) => typeof value === 'string' && value.trim().length > 0
);
